import {
  AREA_ID_PREFIX,
  ActionsFieldNames,
  ActivitiesSubsectionNames,
  ActivitiesTabNames,
  AssetsTabNames,
  AutoLockFormsLevelType,
  AutoLockPageCodes,
  BorrowersSubsectionNames,
  BorrowersTabNames,
  ClosingCompanyTabNames,
  ClosingInformationTabNames,
  ClosingSubsectionNames,
  ConditionsModalNames,
  ContactsTabNames,
  DenialReasonsTabNames,
  DocumentExpirationDatesTabNames,
  FeesSubsectionNames,
  FeesTabNames,
  FinancialInfoSubsectionNames,
  FundingInformationTabNames,
  GeneralTabNames,
  IncomesTabNames,
  LeadSubsectionNames,
  LeadTabNames,
  LiabilitiesTabNames,
  LoanAndLockInfoTabNames,
  LoanEditorSectionNames,
  NonBorrowersTabNames,
  NotesTabNames,
  PostClosingTabNames,
  PropertyAndLoanSubsectionNames,
  PropertyInfoTabNames,
  ReoTabNames,
  TasksSubsectionNames,
  TasksTabNames,
  TitleHolderTabNames,
  UnderwritingSubsectionNames,
} from './autoLockForms.constants';
import {
  addExtensionForm,
  sellSideLockForm,
  additionalFinancingForm,
  additionalLoanInfoForm,
  agentForm,
  appraisalForm,
  assetsForm,
  contactsForm,
  creditsForm,
  customAdjustmentsForm,
  documentVerificationTypesForm,
  employmentIncomeForm,
  existingPropertyExpensesForm,
  liabilitiesForm,
  listingAgentForm,
  loanDetailsForm,
  mortgageInsuranceForm,
  otherExpensesForm,
  paymentInformationForm,
  projectForm,
  propertyAddressForm,
  propertyTaxesForm,
  proposedPropertyExpensesForm,
  reoForm,
  sellerForm,
  supplementalInsurancesForm,
  transactionDetailsForm,
} from './forms';
import { accountingInformationForm } from './forms/accountingInformationForm';
import { activitiesCallsForm } from './forms/activitiesCallsForm';
import { activitiesEmailsForm } from './forms/activitiesEmailsForm';
import { addConditionForm } from './forms/addConditionForm';
import { addConditionsAndConditionsSetsForm } from './forms/addConditionsAndConditionsSetsForm';
import { alternateNamesForm } from './forms/alternateNamesForm';
import { assignTaskForm } from './forms/assignTaskForm';
import { borrowerAddressForm } from './forms/borrowerAddressForm';
import { borrowerInfoForm } from './forms/borrowerInfoForm';
import { closerInformationForm } from './forms/closerInformationForm';
import { closingAgentForm } from './forms/closingAgentForm';
import { closingCompanyInformationForm } from './forms/closingCompanyInformationForm';
import { closingInformationForm } from './forms/closingInformationForm';
import { conditionsTaskInfoForm } from './forms/conditionsTaskInfoForm';
import { creditReportingForm } from './forms/creditReportingForm';
import { declarationsForm } from './forms/declarationsForm';
import { denialReasonsForm } from './forms/denialReasonsForm';
import { documentsListForm } from './forms/documentsListForm';
import { feesForm } from './forms/feesForm';
import { finalDocumentsForm } from './forms/finalDocumentsForm';
import { flippedUnsalableForm } from './forms/flippedUnsalableForm';
import { fundingInformationForm } from './forms/fundingInformationForm';
import { furtherCreditToForm } from './forms/furtherCreditToForm';
import { investorForm } from './forms/investorForm';
import { leadLoanInformationForm } from './forms/leadLoanInformationForm';
import { leadPersonalInformationForm } from './forms/leadPersonalInformationForm';
import { leadPropertyInformationForm } from './forms/leadPropertyInformationForm';
import { mersInformationForm } from './forms/mersInformationForm';
import { nonBorrowerInfoForm } from './forms/nonBorrowerInfoForm';
import { notesForm } from './forms/notesForm';
import { poaForm } from './forms/poaForm';
import { serviceInformationForm } from './forms/serviceInformationForm';
import { shipperMilestoneForm } from './forms/shipperMilestoneForm';
import { shippingInformationForm } from './forms/shippingInformationForm';
import { tasksInformationForm } from './forms/tasksInformationForm';
import { titleHolderGeneralForm } from './forms/titleHolderGeneralForm';
import { titleHolderInformationForm } from './forms/titleHolderInformationForm';
import { trusteeSettlorBeneficiaryForm } from './forms/trusteeSettlorBeneficiaryForm';
import { trustForm } from './forms/trustForm';
import { underwritingDocumentExpirationDatesForm } from './forms/underwritingDocumentExpirationDatesForm';
import { underwritingGeneralForm } from './forms/underwritingGeneralForm';
import { voeIncomeForm } from './forms/voeIncomeForm';
import { wireToInformationForm } from './forms/wireToInformationForm';

// id props reserved for future BE implementation
const appFormsTree = {
  root: {
    children: [
      {
        name: AutoLockPageCodes.LOAN_EDITOR,
        label: 'Loan Editor',
        levelType: AutoLockFormsLevelType.PAGE,
        children: [
          {
            name: LoanEditorSectionNames.PROPERTY_AND_LOAN,
            label: 'Property and Loan',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: PropertyAndLoanSubsectionNames.PROPERTY_INFO,
                label: 'Property Info',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: PropertyInfoTabNames.PROPERTY,
                    label: 'Property',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [propertyAddressForm],
                  },
                  {
                    name: PropertyInfoTabNames.PROJECT,
                    label: 'Project',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [projectForm],
                  },
                  {
                    name: PropertyInfoTabNames.TRANSACTION_DETAILS,
                    label: 'Transaction Details',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [transactionDetailsForm],
                  },
                  {
                    name: PropertyInfoTabNames.AGENT_AND_SELLER,
                    label: 'Agent & Seller',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [agentForm, listingAgentForm, sellerForm],
                  },
                  {
                    name: PropertyInfoTabNames.APPRAISAL,
                    label: 'Appraisal',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [appraisalForm],
                  },
                  {
                    name: PropertyInfoTabNames.PROPERTY_EXPENSES,
                    label: 'Property Expenses',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [
                      proposedPropertyExpensesForm,
                      propertyTaxesForm,
                      supplementalInsurancesForm,
                      otherExpensesForm,
                      existingPropertyExpensesForm,
                    ],
                  },
                ],
              },
              {
                name: PropertyAndLoanSubsectionNames.LOAN_AND_LOCK_INFO,
                label: 'Loan & Lock Info',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: LoanAndLockInfoTabNames.LOAN_INFO,
                    label: 'Loan Info',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [
                      loanDetailsForm,
                      additionalLoanInfoForm,
                      documentVerificationTypesForm,
                      mortgageInsuranceForm,
                    ],
                  },
                  {
                    name: LoanAndLockInfoTabNames.LOCK_INFO,
                    label: 'Lock Info',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [customAdjustmentsForm, addExtensionForm, sellSideLockForm],
                  },
                  {
                    name: LoanAndLockInfoTabNames.CREDITS,
                    label: 'Credits',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [creditsForm],
                  },
                  {
                    name: LoanAndLockInfoTabNames.ADDITIONAL_FINANCING,
                    label: 'Additional Financing',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [additionalFinancingForm],
                  },
                ],
              },
              {
                name: PropertyAndLoanSubsectionNames.CONTACTS,
                label: 'Contacts',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: ContactsTabNames.CONTACTS,
                    label: 'Contacts',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [contactsForm],
                  },
                ],
              },
            ],
          },
          {
            name: LoanEditorSectionNames.BORROWERS,
            label: 'Borrower(s)',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: BorrowersSubsectionNames.BORROWERS,
                label: 'Borrower(s)',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: BorrowersTabNames.BORROWER,
                    label: 'Borrower',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [borrowerInfoForm],
                  },
                  {
                    name: BorrowersTabNames.ADDRESS,
                    label: 'Address',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [borrowerAddressForm],
                  },
                  {
                    name: BorrowersTabNames.CREDIT_REPORTING,
                    label: 'Credit Reporting',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [creditReportingForm],
                  },
                  {
                    name: BorrowersTabNames.ALTERNATE_NAMES,
                    label: 'Alternate Names',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [alternateNamesForm],
                  },
                  {
                    name: BorrowersTabNames.POA,
                    label: 'POA',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [poaForm],
                  },
                  {
                    name: BorrowersTabNames.DECLARATIONS,
                    label: 'Declarations',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [declarationsForm],
                  },
                ],
              },
              {
                name: BorrowersSubsectionNames.NON_BORROWERS,
                label: 'Non Borrowing Entities',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: NonBorrowersTabNames.NBE_INFO,
                    label: 'NBE Info',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [nonBorrowerInfoForm],
                  },
                ],
              },
            ],
          },
          {
            name: LoanEditorSectionNames.FEES,
            label: 'Fees',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: FeesSubsectionNames.Fees,
                label: 'Fees',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: FeesTabNames.FEES,
                    label: 'Fees',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [feesForm],
                  },
                ],
              },
            ],
          },
          {
            name: LoanEditorSectionNames.UNDERWRITING,
            label: 'Underwriting',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: UnderwritingSubsectionNames.NOTES,
                label: 'Notes',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: NotesTabNames.NOTES,
                    label: 'Notes',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [notesForm],
                  },
                ],
              },
              {
                name: UnderwritingSubsectionNames.GENERAL,
                label: 'General',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: GeneralTabNames.GENERAL,
                    label: 'General',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [underwritingGeneralForm],
                  },
                ],
              },
              {
                name: UnderwritingSubsectionNames.DOCUMENT_EXPIRATION_DATES,
                label: 'Document Expiration Dates',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: DocumentExpirationDatesTabNames.DOCUMENT_EXPIRATION_DATES,
                    label: 'Document Expiration Dates',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [underwritingDocumentExpirationDatesForm],
                  },
                ],
              },
              {
                name: UnderwritingSubsectionNames.CONDITIONS,
                label: 'Conditions',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: ConditionsModalNames.ADD_CONDITIONS_AND_CONDITIONS_SETS,
                    label: 'Add Conditions and Conditions Sets',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [addConditionsAndConditionsSetsForm],
                  },
                  {
                    name: ConditionsModalNames.ADD_CONDITION,
                    label: 'Add Condition',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [addConditionForm],
                  },
                  {
                    name: ConditionsModalNames.TASK_INFO,
                    label: 'Task Info',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [conditionsTaskInfoForm],
                  },
                ],
              },
              {
                name: UnderwritingSubsectionNames.DENIAL_REASONS,
                label: 'Denial Reasons',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: DenialReasonsTabNames.DENIAL_REASONS,
                    label: 'Denial Reasons',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [denialReasonsForm],
                  },
                ],
              },
            ],
          },
          {
            name: LoanEditorSectionNames.CLOSING,
            label: 'Closing',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: ClosingSubsectionNames.CLOSING_INFORMATION,
                label: 'Closing Information',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: ClosingInformationTabNames.GENERAL,
                    label: 'Closing Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [closingInformationForm],
                  },
                ],
              },
              {
                name: ClosingSubsectionNames.CLOSING_COMPANIES,
                label: 'Title/Settlement Agent/Attorney(s)',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: ClosingCompanyTabNames.COMPANY_INFORMATION,
                    label: 'Company Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [closingCompanyInformationForm],
                  },
                  {
                    name: ClosingCompanyTabNames.CLOSER_INFORMATION,
                    label: 'Closer Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [closerInformationForm],
                  },
                ],
              },
              {
                name: ClosingSubsectionNames.TITLE_HOLDER,
                label: 'Title Holder',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: TitleHolderTabNames.GENERAL,
                    label: 'Title Holder General',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [titleHolderGeneralForm],
                  },
                  {
                    name: TitleHolderTabNames.TITLE_HOLDER_INFORMATION,
                    label: 'Title Holder Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [titleHolderInformationForm],
                  },
                  {
                    name: TitleHolderTabNames.TRUST,
                    label: 'Trust',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [trustForm],
                  },
                  {
                    name: TitleHolderTabNames.TRUSTEE_SETTLOR_BENEFICIARY,
                    label: 'Trustee/ Settlor/ Beneficiary',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [trusteeSettlorBeneficiaryForm],
                  },
                ],
              },
              {
                name: ClosingSubsectionNames.FUNDING_INFORMATION,
                label: 'Funding Information',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: FundingInformationTabNames.FUNDING_INFORMATION,
                    label: 'Funding Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [fundingInformationForm],
                  },
                  {
                    name: FundingInformationTabNames.CLOSING_AGENT,
                    label: 'Closing Agent',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [closingAgentForm],
                  },
                  {
                    name: FundingInformationTabNames.WIRE_TO_INFORMATION,
                    label: 'Wire To Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [wireToInformationForm],
                  },
                  {
                    name: FundingInformationTabNames.FURTHER_CREDIT_TO,
                    label: 'Further Credit To',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [furtherCreditToForm],
                  },
                ],
              },
              {
                name: ClosingSubsectionNames.POST_CLOSING,
                label: 'Post Closing',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: PostClosingTabNames.SHIPPING_INFORMATION,
                    label: 'Shipping Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [shippingInformationForm],
                  },
                  {
                    name: PostClosingTabNames.INVESTOR,
                    label: 'Investor',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [investorForm],
                  },
                  {
                    name: PostClosingTabNames.ACCOUNTING_INFORMATION,
                    label: 'Accounting Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [accountingInformationForm],
                  },
                  {
                    name: PostClosingTabNames.SERVICER_INFORMATION,
                    label: 'Servicer Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [serviceInformationForm],
                  },
                  {
                    name: PostClosingTabNames.MERS_INFORMATION,
                    label: 'MERS',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [mersInformationForm],
                  },
                  {
                    name: PostClosingTabNames.PAYMENT_INFORMATION,
                    label: 'Payment Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [paymentInformationForm],
                  },
                  {
                    name: PostClosingTabNames.DOCUMENTS_LIST,
                    label: 'Documents List',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [documentsListForm],
                  },
                  {
                    name: PostClosingTabNames.FINAL_DOCUMENTS,
                    label: 'Final Documents',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [finalDocumentsForm],
                  },
                  {
                    name: PostClosingTabNames.SHIPPER_MILESTONE,
                    label: 'Shipper Milestone',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [shipperMilestoneForm],
                  },
                  {
                    name: PostClosingTabNames.FLIPPED_UNSALABLE,
                    label: 'Flipped / Unsalable',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [flippedUnsalableForm],
                  },
                ],
              },
            ],
          },
          {
            name: LoanEditorSectionNames.LEAD,
            label: 'Lead Summary',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: LeadSubsectionNames.LeadDetails,
                label: 'Lead Details',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: LeadTabNames.PERSONAL_INFORMATION,
                    label: 'Personal Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [leadPersonalInformationForm],
                  },
                  {
                    name: LeadTabNames.LOAN_INFORMATION,
                    label: 'Loan Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [leadLoanInformationForm],
                  },
                  {
                    name: LeadTabNames.PROPERTY_INFORMATION,
                    label: 'Property Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [leadPropertyInformationForm],
                  },
                ],
              },
            ],
          },
          {
            name: LoanEditorSectionNames.ACTIVITIES,
            label: 'Activities',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: ActivitiesSubsectionNames.ACTIVITIES,
                label: 'Activities',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: ActivitiesTabNames.EMAILS,
                    label: 'Emails',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [activitiesEmailsForm],
                  },
                  {
                    name: ActivitiesTabNames.CALLS,
                    label: 'Calls',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [activitiesCallsForm],
                  },
                ],
              },
            ],
          },
          {
            name: LoanEditorSectionNames.TASKS,
            label: 'Tasks',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: TasksSubsectionNames.TASKS,
                label: 'Tasks',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: TasksTabNames.ASSIGN_TASK,
                    label: 'Assign Task',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [assignTaskForm],
                  },
                  {
                    name: TasksTabNames.TASK_INFORMATION,
                    label: 'Task Information',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [tasksInformationForm],
                  },
                ],
              },
            ],
          },
          {
            name: LoanEditorSectionNames.FINANCIAL_INFO,
            label: 'Financial Info',
            levelType: AutoLockFormsLevelType.SECTION,
            children: [
              {
                name: FinancialInfoSubsectionNames.EMPLOYMENT_INFO,
                label: 'Employment & Income',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: IncomesTabNames.INCOME_AND_EMPLOYMENT,
                    label: 'Employment & Income',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [employmentIncomeForm, voeIncomeForm],
                  },
                ],
              },
              {
                name: FinancialInfoSubsectionNames.LIABILITIES,
                label: 'Liabilities',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: LiabilitiesTabNames.LIABILITIES,
                    label: 'Liabilities',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [liabilitiesForm],
                  },
                ],
              },
              {
                name: FinancialInfoSubsectionNames.REO,
                label: 'REO',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: ReoTabNames.REO,
                    label: 'REO',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [reoForm],
                  },
                ],
              },
              {
                name: FinancialInfoSubsectionNames.ASSETS,
                label: 'Assets',
                levelType: AutoLockFormsLevelType.SUBSECTION,
                children: [
                  {
                    name: AssetsTabNames.ASSETS,
                    label: 'Assets',
                    levelType: AutoLockFormsLevelType.TAB,
                    children: [assetsForm],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: AutoLockPageCodes.ACTIONS,
        label: 'Actions',
        levelType: AutoLockFormsLevelType.SECTION,
        children: [
          {
            name: AutoLockPageCodes.ACTIONS,
            label: 'Actions',
            levelType: AutoLockFormsLevelType.SUBSECTION,
            children: [
              {
                name: AutoLockPageCodes.ACTIONS,
                label: 'Actions',
                levelType: AutoLockFormsLevelType.TAB,
                children: [
                  {
                    name: AutoLockPageCodes.ACTIONS,
                    label: 'Actions',
                    levelType: AutoLockFormsLevelType.FORM,
                    children: [
                      {
                        name: ActionsFieldNames.PROGRAM_CHANGE,
                        label: 'Program Change',
                        levelType: AutoLockFormsLevelType.FIELD,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export { AREA_ID_PREFIX };

const getAreaId = ({ levelType, page, section, subsection, tab, form }) => {
  if (levelType === AutoLockFormsLevelType.PAGE) {
    return `${AREA_ID_PREFIX[AutoLockFormsLevelType.PAGE]}${page}`;
  }

  if (levelType === AutoLockFormsLevelType.SECTION) {
    return `${AREA_ID_PREFIX[AutoLockFormsLevelType.SECTION]}${section}`;
  }

  if (levelType === AutoLockFormsLevelType.SUBSECTION) {
    return `${AREA_ID_PREFIX[AutoLockFormsLevelType.SUBSECTION]}${section}-${subsection}`;
  }

  if (levelType === AutoLockFormsLevelType.TAB) {
    return `${AREA_ID_PREFIX[AutoLockFormsLevelType.TAB]}${section}-${subsection}-${tab}`;
  }

  if (levelType === AutoLockFormsLevelType.FORM) {
    return `${section}-${subsection}-${tab}-${form}`;
  }

  return null;
};

const createAreaNode = ({
  levelType,
  page,
  pageLabel,
  section,
  sectionLabel,
  subsection,
  subsectionLabel,
  tab,
  tabLabel,
  form,
  formLabel,
  item,
  parentId,
  ancestorIds,
  depth,
}) => ({
  id: getAreaId({ levelType, page, section, subsection, tab, form }),
  levelType,
  name: item.name,
  label: item.label,
  page,
  pageLabel,
  section,
  sectionLabel,
  subsection,
  subsectionLabel,
  tab,
  tabLabel,
  form,
  formLabel,
  parentId,
  ancestorIds,
  depth,
  childIds: [],
  descendantAreaIds: [],
  descendantFieldIds: [],
  descendantFormIds: [],
});

const handleItem = (acc, item, parentAreaIds) => {
  const nextParents = [...parentAreaIds];

  if (item.levelType === AutoLockFormsLevelType.PAGE) {
    acc.currentPage = item.name;
    acc.currentPageLabel = item.label;
  }

  if (item.levelType === AutoLockFormsLevelType.SECTION) {
    acc.currentSection = item.name;
    acc.currentSectionLabel = item.label;
  }

  if (item.levelType === AutoLockFormsLevelType.SUBSECTION) {
    acc.currentSubSection = item.name;
    acc.currentSubSectionLabel = item.label;
  }

  if (item.levelType === AutoLockFormsLevelType.TAB) {
    acc.currentTab = item.name;
    acc.currentTabLabel = item.label;
  }

  if (item.levelType === AutoLockFormsLevelType.FORM) {
    acc.currentForm = item.name;
    acc.currentFormLabel = item.label;
  }

  const isAreaLevel = [
    AutoLockFormsLevelType.PAGE,
    AutoLockFormsLevelType.SECTION,
    AutoLockFormsLevelType.SUBSECTION,
    AutoLockFormsLevelType.TAB,
    AutoLockFormsLevelType.FORM,
  ].includes(item.levelType);

  if (isAreaLevel) {
    const parentId = parentAreaIds[parentAreaIds.length - 1] || null;
    const areaNode = createAreaNode({
      levelType: item.levelType,
      page: acc.currentPage,
      pageLabel: acc.currentPageLabel,
      section: acc.currentSection,
      sectionLabel: acc.currentSectionLabel,
      subsection: acc.currentSubSection,
      subsectionLabel: acc.currentSubSectionLabel,
      tab: acc.currentTab,
      tabLabel: acc.currentTabLabel,
      form: acc.currentForm,
      formLabel: acc.currentFormLabel,
      item,
      parentId,
      ancestorIds: [...parentAreaIds],
      depth: parentAreaIds.length,
    });

    acc.areaNodes.push(areaNode);
    acc.areaNodeMap[areaNode.id] = areaNode;

    if (parentId && acc.areaNodeMap[parentId]) {
      acc.areaNodeMap[parentId].childIds.push(areaNode.id);
    }

    parentAreaIds.forEach(ancestorId => {
      acc.areaNodeMap[ancestorId].descendantAreaIds.push(areaNode.id);
    });

    nextParents.push(areaNode.id);
  }

  if (item.levelType === AutoLockFormsLevelType.FIELD) {
    const option = {
      page: acc.currentPage,
      pageLabel: acc.currentPageLabel,
      section: acc.currentSection,
      sectionLabel: acc.currentSectionLabel,
      subsection: acc.currentSubSection,
      subsectionLabel: acc.currentSubSectionLabel,
      tab: acc.currentTab,
      tabLabel: acc.currentTabLabel,
      form: acc.currentForm,
      formLabel: acc.currentFormLabel,
      name: item.label,
      value: `${acc.currentSection}-${acc.currentSubSection}-${acc.currentTab}-${acc.currentForm}-${item.name}`,
      ancestorAreaIds: parentAreaIds,
    };

    acc.options.push(option);
    acc.optionsMap[option.value] = option;

    parentAreaIds.forEach(areaId => {
      acc.areaNodeMap[areaId].descendantFieldIds.push(option.value);
    });

    const formAreaId = parentAreaIds[parentAreaIds.length - 1];

    parentAreaIds.slice(0, -1).forEach(areaId => {
      if (!acc.areaNodeMap[areaId].descendantFormIds.includes(formAreaId)) {
        acc.areaNodeMap[areaId].descendantFormIds.push(formAreaId);
      }
    });

    return acc;
  }

  item.children.forEach(child => {
    handleItem(acc, child, nextParents);
  });

  return acc;
};

const buildArtifactsFromRoot = rootChildren =>
  rootChildren.reduce((acc, child) => handleItem(acc, child, []), {
    currentPage: '',
    currentPageLabel: '',
    currentSection: '',
    currentSectionLabel: '',
    currentSubSection: '',
    currentSubSectionLabel: '',
    currentTab: '',
    currentTabLabel: '',
    currentForm: '',
    currentFormLabel: '',
    options: [],
    optionsMap: {},
    areaNodes: [],
    areaNodeMap: {},
  });

const baseArtifacts = buildArtifactsFromRoot(appFormsTree.root.children);

export const appFormsTreeFieldOptions = baseArtifacts.options;
export const appFormsTreeFieldOptionsMap = baseArtifacts.optionsMap;
export const appFormsTreeAreaNodes = baseArtifacts.areaNodes;
export const appFormsTreeAreaNodeMap = baseArtifacts.areaNodeMap;

const extendedArtifacts = {
  options: [...baseArtifacts.options],
  optionsMap: { ...baseArtifacts.optionsMap },
  areaNodes: [...baseArtifacts.areaNodes],
  areaNodeMap: { ...baseArtifacts.areaNodeMap },
};

export const appFormsTreeFieldOptionsExtended = extendedArtifacts.options;
export const appFormsTreeFieldOptionsMapExtended = extendedArtifacts.optionsMap;
export const appFormsTreeAreaNodesExtended = extendedArtifacts.areaNodes;
export const appFormsTreeAreaNodeMapExtended = extendedArtifacts.areaNodeMap;

const appFormsTreeMutationState = { version: 0 };
const registeredSyntheticIds = { areas: [], fields: [] };

export const createAppFormsTreeVersionedAccessor = builder => {
  const cache = { value: null, version: -1 };

  return () => {
    const currentVersion = appFormsTreeMutationState.version;

    if (cache.version !== currentVersion) {
      cache.value = builder();
      cache.version = currentVersion;
    }

    return cache.value;
  };
};

const removeSyntheticEntriesFromExtendedArtifacts = () => {
  const areaIdSet = new Set(registeredSyntheticIds.areas);
  const fieldIdSet = new Set(registeredSyntheticIds.fields);

  if (areaIdSet.size > 0) {
    const filteredAreaNodes = extendedArtifacts.areaNodes.filter(node => !areaIdSet.has(node.id));
    extendedArtifacts.areaNodes.length = 0;
    extendedArtifacts.areaNodes.push(...filteredAreaNodes);

    areaIdSet.forEach(id => {
      delete extendedArtifacts.areaNodeMap[id];
    });
  }

  if (fieldIdSet.size > 0) {
    const filteredOptions = extendedArtifacts.options.filter(
      option => !fieldIdSet.has(option.value),
    );
    extendedArtifacts.options.length = 0;
    extendedArtifacts.options.push(...filteredOptions);

    fieldIdSet.forEach(id => {
      delete extendedArtifacts.optionsMap[id];
    });
  }

  registeredSyntheticIds.areas = [];
  registeredSyntheticIds.fields = [];
};

const mergeSyntheticArtifactsIntoExtended = synthetic => {
  synthetic.areaNodes.forEach(node => {
    extendedArtifacts.areaNodes.push(node);
    extendedArtifacts.areaNodeMap[node.id] = node;
    registeredSyntheticIds.areas.push(node.id);
  });

  synthetic.options.forEach(option => {
    extendedArtifacts.options.push(option);
    extendedArtifacts.optionsMap[option.value] = option;
    registeredSyntheticIds.fields.push(option.value);
  });
};

export const registerLoanEditorCustomFormsInAppFormsTree = syntheticBranch => {
  removeSyntheticEntriesFromExtendedArtifacts();

  if (syntheticBranch) {
    const synthetic = buildArtifactsFromRoot([syntheticBranch]);
    mergeSyntheticArtifactsIntoExtended(synthetic);
  }

  appFormsTreeMutationState.version += 1;
};
